import React from "react";
import style from "./loader.module.css"


export const LoaderDotted = () =>{
    /**
     * This is react component for a dotted loader
     */
    return <span className={style.loader}></span>
}